import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-hot-toast";
import {
    useCreateCTAPopupMutation,
    CreateCTARequest
} from "../../store/slices/apiSlice";
import { Card } from "../../components/ui/Card";
import { PageHeader } from "../../components/ui/PageHeader";
import { Button } from "../../components/ui/Button";
import {
    ArrowLeft,
    Save,
    Upload,
    Globe,
    ChevronDown,
    X,
    Search
} from 'lucide-react';
import { useNavigate, useLocation } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";

// ── World Countries List ────────────────────────────────────────────────────────
const WORLD_COUNTRIES = [
    { code: 'AF', name: 'Afghanistan' }, { code: 'AL', name: 'Albania' }, { code: 'DZ', name: 'Algeria' },
    { code: 'AD', name: 'Andorra' }, { code: 'AO', name: 'Angola' }, { code: 'AG', name: 'Antigua & Barbuda' },
    { code: 'AR', name: 'Argentina' }, { code: 'AM', name: 'Armenia' }, { code: 'AU', name: 'Australia' },
    { code: 'AT', name: 'Austria' }, { code: 'AZ', name: 'Azerbaijan' }, { code: 'BS', name: 'Bahamas' },
    { code: 'BH', name: 'Bahrain' }, { code: 'BD', name: 'Bangladesh' }, { code: 'BB', name: 'Barbados' },
    { code: 'BY', name: 'Belarus' }, { code: 'BE', name: 'Belgium' }, { code: 'BZ', name: 'Belize' },
    { code: 'BJ', name: 'Benin' }, { code: 'BT', name: 'Bhutan' }, { code: 'BO', name: 'Bolivia' },
    { code: 'BA', name: 'Bosnia & Herzegovina' }, { code: 'BW', name: 'Botswana' }, { code: 'BR', name: 'Brazil' },
    { code: 'BN', name: 'Brunei' }, { code: 'BG', name: 'Bulgaria' }, { code: 'BF', name: 'Burkina Faso' },
    { code: 'BI', name: 'Burundi' }, { code: 'CV', name: 'Cabo Verde' }, { code: 'KH', name: 'Cambodia' },
    { code: 'CM', name: 'Cameroon' }, { code: 'CA', name: 'Canada' }, { code: 'CF', name: 'Central African Republic' },
    { code: 'TD', name: 'Chad' }, { code: 'CL', name: 'Chile' }, { code: 'CN', name: 'China' },
    { code: 'CO', name: 'Colombia' }, { code: 'KM', name: 'Comoros' }, { code: 'CG', name: 'Congo' },
    { code: 'CD', name: 'Congo (DR)' }, { code: 'CR', name: 'Costa Rica' }, { code: 'CI', name: "Côte d'Ivoire" },
    { code: 'HR', name: 'Croatia' }, { code: 'CU', name: 'Cuba' }, { code: 'CY', name: 'Cyprus' },
    { code: 'CZ', name: 'Czech Republic' }, { code: 'DK', name: 'Denmark' }, { code: 'DJ', name: 'Djibouti' },
    { code: 'DM', name: 'Dominica' }, { code: 'DO', name: 'Dominican Republic' }, { code: 'EC', name: 'Ecuador' },
    { code: 'EG', name: 'Egypt' }, { code: 'SV', name: 'El Salvador' }, { code: 'GQ', name: 'Equatorial Guinea' },
    { code: 'ER', name: 'Eritrea' }, { code: 'EE', name: 'Estonia' }, { code: 'SZ', name: 'Eswatini' },
    { code: 'ET', name: 'Ethiopia' }, { code: 'FJ', name: 'Fiji' }, { code: 'FI', name: 'Finland' },
    { code: 'FR', name: 'France' }, { code: 'GA', name: 'Gabon' }, { code: 'GM', name: 'Gambia' },
    { code: 'GE', name: 'Georgia' }, { code: 'DE', name: 'Germany' }, { code: 'GH', name: 'Ghana' },
    { code: 'GR', name: 'Greece' }, { code: 'GD', name: 'Grenada' }, { code: 'GT', name: 'Guatemala' },
    { code: 'GN', name: 'Guinea' }, { code: 'GW', name: 'Guinea-Bissau' }, { code: 'GY', name: 'Guyana' },
    { code: 'HT', name: 'Haiti' }, { code: 'HN', name: 'Honduras' }, { code: 'HU', name: 'Hungary' },
    { code: 'IS', name: 'Iceland' }, { code: 'IN', name: 'India' }, { code: 'ID', name: 'Indonesia' },
    { code: 'IR', name: 'Iran' }, { code: 'IQ', name: 'Iraq' }, { code: 'IE', name: 'Ireland' },
    { code: 'IL', name: 'Israel' }, { code: 'IT', name: 'Italy' }, { code: 'JM', name: 'Jamaica' },
    { code: 'JP', name: 'Japan' }, { code: 'JO', name: 'Jordan' }, { code: 'KZ', name: 'Kazakhstan' },
    { code: 'KE', name: 'Kenya' }, { code: 'KI', name: 'Kiribati' }, { code: 'KP', name: 'Korea (North)' },
    { code: 'KR', name: 'Korea (South)' }, { code: 'KW', name: 'Kuwait' }, { code: 'KG', name: 'Kyrgyzstan' },
    { code: 'LA', name: 'Laos' }, { code: 'LV', name: 'Latvia' }, { code: 'LB', name: 'Lebanon' },
    { code: 'LS', name: 'Lesotho' }, { code: 'LR', name: 'Liberia' }, { code: 'LY', name: 'Libya' },
    { code: 'LI', name: 'Liechtenstein' }, { code: 'LT', name: 'Lithuania' }, { code: 'LU', name: 'Luxembourg' },
    { code: 'MG', name: 'Madagascar' }, { code: 'MW', name: 'Malawi' }, { code: 'MY', name: 'Malaysia' },
    { code: 'MV', name: 'Maldives' }, { code: 'ML', name: 'Mali' }, { code: 'MT', name: 'Malta' },
    { code: 'MH', name: 'Marshall Islands' }, { code: 'MR', name: 'Mauritania' }, { code: 'MU', name: 'Mauritius' },
    { code: 'MX', name: 'Mexico' }, { code: 'FM', name: 'Micronesia' }, { code: 'MD', name: 'Moldova' },
    { code: 'MC', name: 'Monaco' }, { code: 'MN', name: 'Mongolia' }, { code: 'ME', name: 'Montenegro' },
    { code: 'MA', name: 'Morocco' }, { code: 'MZ', name: 'Mozambique' }, { code: 'MM', name: 'Myanmar' },
    { code: 'NA', name: 'Namibia' }, { code: 'NR', name: 'Nauru' }, { code: 'NP', name: 'Nepal' },
    { code: 'NL', name: 'Netherlands' }, { code: 'NZ', name: 'New Zealand' }, { code: 'NI', name: 'Nicaragua' },
    { code: 'NE', name: 'Niger' }, { code: 'NG', name: 'Nigeria' }, { code: 'MK', name: 'North Macedonia' },
    { code: 'NO', name: 'Norway' }, { code: 'OM', name: 'Oman' }, { code: 'PK', name: 'Pakistan' },
    { code: 'PW', name: 'Palau' }, { code: 'PA', name: 'Panama' }, { code: 'PG', name: 'Papua New Guinea' },
    { code: 'PY', name: 'Paraguay' }, { code: 'PE', name: 'Peru' }, { code: 'PH', name: 'Philippines' },
    { code: 'PL', name: 'Poland' }, { code: 'PT', name: 'Portugal' }, { code: 'QA', name: 'Qatar' },
    { code: 'RO', name: 'Romania' }, { code: 'RU', name: 'Russia' }, { code: 'RW', name: 'Rwanda' },
    { code: 'KN', name: 'Saint Kitts & Nevis' }, { code: 'LC', name: 'Saint Lucia' },
    { code: 'VC', name: 'Saint Vincent & the Grenadines' }, { code: 'WS', name: 'Samoa' },
    { code: 'SM', name: 'San Marino' }, { code: 'ST', name: 'São Tomé & Príncipe' },
    { code: 'SA', name: 'Saudi Arabia' }, { code: 'SN', name: 'Senegal' }, { code: 'RS', name: 'Serbia' },
    { code: 'SC', name: 'Seychelles' }, { code: 'SL', name: 'Sierra Leone' }, { code: 'SG', name: 'Singapore' },
    { code: 'SK', name: 'Slovakia' }, { code: 'SI', name: 'Slovenia' }, { code: 'SB', name: 'Solomon Islands' },
    { code: 'SO', name: 'Somalia' }, { code: 'ZA', name: 'South Africa' }, { code: 'SS', name: 'South Sudan' },
    { code: 'ES', name: 'Spain' }, { code: 'LK', name: 'Sri Lanka' }, { code: 'SD', name: 'Sudan' },
    { code: 'SR', name: 'Suriname' }, { code: 'SE', name: 'Sweden' }, { code: 'CH', name: 'Switzerland' },
    { code: 'SY', name: 'Syria' }, { code: 'TW', name: 'Taiwan' }, { code: 'TJ', name: 'Tajikistan' },
    { code: 'TZ', name: 'Tanzania' }, { code: 'TH', name: 'Thailand' }, { code: 'TL', name: 'Timor-Leste' },
    { code: 'TG', name: 'Togo' }, { code: 'TO', name: 'Tonga' }, { code: 'TT', name: 'Trinidad & Tobago' },
    { code: 'TN', name: 'Tunisia' }, { code: 'TR', name: 'Turkey' }, { code: 'TM', name: 'Turkmenistan' },
    { code: 'TV', name: 'Tuvalu' }, { code: 'UG', name: 'Uganda' }, { code: 'UA', name: 'Ukraine' },
    { code: 'AE', name: 'United Arab Emirates' }, { code: 'GB', name: 'United Kingdom' },
    { code: 'US', name: 'United States' }, { code: 'UY', name: 'Uruguay' }, { code: 'UZ', name: 'Uzbekistan' },
    { code: 'VU', name: 'Vanuatu' }, { code: 'VE', name: 'Venezuela' }, { code: 'VN', name: 'Vietnam' },
    { code: 'YE', name: 'Yemen' }, { code: 'ZM', name: 'Zambia' }, { code: 'ZW', name: 'Zimbabwe' },
];

// ── Country Multi-Select Component ─────────────────────────────────────────────
interface CountryMultiSelectProps {
    value: string[];
    onChange: (codes: string[]) => void;
    error?: string;
}

const CountryMultiSelect: React.FC<CountryMultiSelectProps> = ({ value, onChange, error }) => {
    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState('');
    const dropdownRef = useRef<HTMLDivElement>(null);

    const isAllCountries = value.length === 0;

    const filtered = WORLD_COUNTRIES.filter(c =>
        c.name.toLowerCase().includes(search.toLowerCase()) ||
        c.code.toLowerCase().includes(search.toLowerCase())
    );

    const toggleCountry = (code: string) => {
        if (value.includes(code)) {
            onChange(value.filter(c => c !== code));
        } else {
            onChange([...value, code]);
        }
    };

    const selectAll = () => { onChange([]); setOpen(false); };
    const removeCountry = (code: string, e: React.MouseEvent) => {
        e.stopPropagation();
        onChange(value.filter(c => c !== code));
    };

    // Close when clicking outside
    useEffect(() => {
        const handler = (e: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);

    const getLabel = () => {
        if (isAllCountries) return null;
        return value.map(code => WORLD_COUNTRIES.find(c => c.code === code)?.name || code).join(', ');
    };

    return (
        <div className="relative" ref={dropdownRef}>
            {/* Trigger */}
            <div
                className={`w-full min-h-[46px] px-3 py-2 border rounded-lg cursor-pointer flex flex-wrap gap-1 items-center focus-within:ring-2 focus-within:ring-primary-500 transition-colors ${error ? 'border-red-300' : 'border-gray-300'}`}
                onClick={() => setOpen(!open)}
            >
                {isAllCountries ? (
                    <span className="flex items-center gap-2 text-green-700 font-medium">
                        <Globe size={14} className="text-green-600" />
                        All Countries (Global)
                    </span>
                ) : (
                    <>
                        {value.map(code => {
                            const country = WORLD_COUNTRIES.find(c => c.code === code);
                            return (
                                <span key={code} className="inline-flex items-center gap-1 px-2 py-0.5 bg-purple-100 text-purple-800 text-xs rounded-full">
                                    {country?.name || code}
                                    <button type="button" onClick={(e) => removeCountry(code, e)} className="hover:text-purple-600">
                                        <X size={10} />
                                    </button>
                                </span>
                            );
                        })}
                    </>
                )}
                <ChevronDown size={16} className={`ml-auto text-gray-400 flex-shrink-0 transition-transform ${open ? 'rotate-180' : ''}`} />
            </div>

            {/* Dropdown */}
            {open && (
                <div className="absolute z-50 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-xl max-h-72 flex flex-col">
                    {/* Search */}
                    <div className="p-2 border-b border-gray-100">
                        <div className="relative">
                            <Search size={14} className="absolute left-2 top-1/2 -translate-y-1/2 text-gray-400" />
                            <input
                                type="text"
                                placeholder="Search country..."
                                value={search}
                                onChange={e => setSearch(e.target.value)}
                                className="w-full pl-7 pr-3 py-1.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-1 focus:ring-purple-400"
                                onClick={e => e.stopPropagation()}
                                autoFocus
                            />
                        </div>
                    </div>

                    <div className="overflow-y-auto flex-1">
                        {/* All Countries option */}
                        <button
                            type="button"
                            onClick={selectAll}
                            className={`w-full flex items-center gap-2 px-3 py-2 text-sm hover:bg-green-50 transition-colors ${isAllCountries ? 'bg-green-50 font-semibold text-green-700' : 'text-gray-700'}`}
                        >
                            <Globe size={14} className="text-green-600 flex-shrink-0" />
                            <span>All Countries (Global)</span>
                            {isAllCountries && <span className="ml-auto text-green-600 text-xs">✓ Selected</span>}
                        </button>
                        <div className="border-t border-gray-100 mx-2" />

                        {/* Country list */}
                        {filtered.map(country => {
                            const selected = value.includes(country.code);
                            return (
                                <button
                                    key={country.code}
                                    type="button"
                                    onClick={() => toggleCountry(country.code)}
                                    className={`w-full flex items-center justify-between px-3 py-2 text-sm hover:bg-purple-50 transition-colors ${selected ? 'bg-purple-50 text-purple-800' : 'text-gray-700'}`}
                                >
                                    <span>{country.name}</span>
                                    <div className="flex items-center gap-2">
                                        <span className="text-xs text-gray-400">{country.code}</span>
                                        {selected && <span className="text-purple-600 text-xs">✓</span>}
                                    </div>
                                </button>
                            );
                        })}

                        {filtered.length === 0 && (
                            <p className="px-3 py-4 text-center text-sm text-gray-500">No countries found</p>
                        )}
                    </div>

                    {/* Footer */}
                    {value.length > 0 && (
                        <div className="p-2 border-t border-gray-100 bg-gray-50 text-xs text-gray-500 flex justify-between items-center">
                            <span>{value.length} countr{value.length === 1 ? 'y' : 'ies'} selected</span>
                            <button type="button" onClick={selectAll} className="text-purple-600 hover:underline">Clear all</button>
                        </div>
                    )}
                </div>
            )}
            {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
        </div>
    );
};

// ── Validation Schema ───────────────────────────────────────────────────────────
const CTAValidationSchema = Yup.object({
    title: Yup.string().required("Title is required"),
    description: Yup.string().required("Description is required"),
    button_text: Yup.string().required("Button text is required"),
    href: Yup.string().url("Must be a valid URL").required("Link is required"),
    file_type: Yup.string().required("File type is required"),
});

interface FormValues {
    title: string;
    description: string;
    button_text: string;
    href: string;
    file_type: 'image' | 'video';
    file: File | null;
    thumbnail_image: File | null;
    target_countries: string[]; // empty = All Countries (global)
}

// ── Main Component ──────────────────────────────────────────────────────────────
export const CTAAdd: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [fileList, setFileList] = useState<File[]>([]);
    const [thumbnailList, setThumbnailList] = useState<File[]>([]);
    const [previewUrl, setPreviewUrl] = useState("");
    const [thumbnailPreviewUrl, setThumbnailPreviewUrl] = useState("");

    const basePath = location.pathname.startsWith('/admin') ? '/admin' : '/dashboard';
    const [createCTAPopup, { isLoading: isCreating }] = useCreateCTAPopupMutation();

    const formik = useFormik<FormValues>({
        initialValues: {
            title: "",
            description: "",
            button_text: "",
            href: "",
            file_type: "image" as 'image' | 'video',
            file: null as File | null,
            thumbnail_image: null as File | null,
            target_countries: [], // empty = global
        },
        validationSchema: CTAValidationSchema,
        onSubmit: async (values, { resetForm }) => {
            try {
                const formData = new FormData();
                formData.append("title", values.title);
                formData.append("description", values.description);
                formData.append("button_text", values.button_text);
                formData.append("href", values.href);
                formData.append("file_type", values.file_type);

                // Send target_countries as JSON string — empty array = null (global)
                formData.append(
                    "target_countries",
                    values.target_countries.length > 0 ? JSON.stringify(values.target_countries) : 'null'
                );

                if (values.file) formData.append("file", values.file);
                if (values.thumbnail_image) formData.append("thumbnail_image", values.thumbnail_image);

                await createCTAPopup(formData).unwrap();
                toast.success("Ad created successfully!");
                resetForm();
                setFileList([]);
                setThumbnailList([]);
                setPreviewUrl("");
                setThumbnailPreviewUrl("");
                navigate(`${basePath}/cta-management`);
            } catch (error: any) {
                if (error?.status === 400) toast.error('Bad Request: Please check your form data.');
                else if (error?.status === 401) toast.error('Unauthorized: Please log in again.');
                else if (error?.status === 413) toast.error('File too large.');
                else toast.error('Failed to create Ad. Please try again.');
            }
        },
    });

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>, field: 'file' | 'thumbnail_image') => {
        const file = event.target.files?.[0];
        if (file) {
            const maxSize = formik.values.file_type === "image" ? 5 * 1024 * 1024 : 50 * 1024 * 1024;
            if (file.size > maxSize) {
                toast.error(`File size must be less than ${formik.values.file_type === "image" ? "5MB" : "50MB"}`);
                return;
            }
            if (field === "file") {
                if (formik.values.file_type === "image" && !file.type.startsWith("image/")) { toast.error("Please select an image file"); return; }
                if (formik.values.file_type === "video" && !file.type.startsWith("video/")) { toast.error("Please select a video file"); return; }
            } else if (field === "thumbnail_image" && !file.type.startsWith("image/")) {
                toast.error("Please select an image file for thumbnail"); return;
            }
            formik.setFieldValue(field, file);
            if (field === "file") { setFileList([file]); setPreviewUrl(URL.createObjectURL(file)); }
            else { setThumbnailList([file]); setThumbnailPreviewUrl(URL.createObjectURL(file)); }
        }
    };

    const handleFileRemove = (field: 'file' | 'thumbnail_image') => {
        if (field === "file") { setFileList([]); if (previewUrl) URL.revokeObjectURL(previewUrl); setPreviewUrl(""); formik.setFieldValue("file", null); }
        else { setThumbnailList([]); if (thumbnailPreviewUrl) URL.revokeObjectURL(thumbnailPreviewUrl); setThumbnailPreviewUrl(""); formik.setFieldValue("thumbnail_image", null); }
    };

    const handleFileTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        formik.setFieldValue("file_type", e.target.value);
        formik.setFieldValue("file", null); formik.setFieldValue("thumbnail_image", null);
        setFileList([]); setThumbnailList([]); setPreviewUrl(""); setThumbnailPreviewUrl("");
    };

    const getFieldError = (fieldName: keyof FormValues) =>
        formik.touched[fieldName] && formik.errors[fieldName] ? formik.errors[fieldName] as string : "";

    useEffect(() => {
        return () => {
            if (previewUrl) URL.revokeObjectURL(previewUrl);
            if (thumbnailPreviewUrl) URL.revokeObjectURL(thumbnailPreviewUrl);
        };
    }, [previewUrl, thumbnailPreviewUrl]);

    if (isCreating) {
        return (
            <div className="flex items-center justify-center h-96">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
                    <p className="mt-4 text-gray-600">Creating Ad...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="space-y-6">
            <PageHeader title="Add App Ads Slider" description="Create a new app ads slider">
                <Button variant="outline" onClick={() => navigate(`${basePath}/cta-management`)} className="flex items-center gap-2">
                    <ArrowLeft size={20} /> Back to Ads
                </Button>
            </PageHeader>

            <Card>
                <form onSubmit={formik.handleSubmit} className="space-y-6 p-8">
                    {/* Basic Information */}
                    <div className="border-b border-gray-200 pb-6">
                        <h2 className="text-lg font-semibold text-gray-900 mb-4">Basic Information</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div>
                                <label htmlFor="title" className="block text-sm font-medium text-gray-700 mb-2">Title <span className="text-red-500">*</span></label>
                                <input type="text" id="title" name="title" placeholder="Enter ad title"
                                    className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 transition-colors ${getFieldError("title") ? "border-red-300" : "border-gray-300"}`}
                                    onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.title} />
                                {getFieldError("title") && <p className="text-red-500 text-xs mt-1">{getFieldError("title")}</p>}
                            </div>
                            <div>
                                <label htmlFor="file_type" className="block text-sm font-medium text-gray-700 mb-2">File Type <span className="text-red-500">*</span></label>
                                <select id="file_type" name="file_type"
                                    className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 transition-colors ${getFieldError("file_type") ? "border-red-300" : "border-gray-300"}`}
                                    onChange={handleFileTypeChange} onBlur={formik.handleBlur} value={formik.values.file_type}>
                                    <option value="image">Image</option>
                                    <option value="video">Video</option>
                                </select>
                            </div>
                        </div>
                        <div className="mt-6">
                            <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-2">Description <span className="text-red-500">*</span></label>
                            <textarea id="description" name="description" placeholder="Enter ad description" rows={4}
                                className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 transition-colors resize-none ${getFieldError("description") ? "border-red-300" : "border-gray-300"}`}
                                onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.description} />
                            {getFieldError("description") && <p className="text-red-500 text-xs mt-1">{getFieldError("description")}</p>}
                        </div>
                    </div>

                    {/* Button & Link */}
                    <div className="border-b border-gray-200 pb-6">
                        <h2 className="text-lg font-semibold text-gray-900 mb-4">Button & Link Configuration</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div>
                                <label htmlFor="button_text" className="block text-sm font-medium text-gray-700 mb-2">Button Text <span className="text-red-500">*</span></label>
                                <input type="text" id="button_text" name="button_text" placeholder="e.g., Click Here, Learn More"
                                    className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 transition-colors ${getFieldError("button_text") ? "border-red-300" : "border-gray-300"}`}
                                    onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.button_text} />
                                {getFieldError("button_text") && <p className="text-red-500 text-xs mt-1">{getFieldError("button_text")}</p>}
                            </div>
                            <div>
                                <label htmlFor="href" className="block text-sm font-medium text-gray-700 mb-2">Link URL <span className="text-red-500">*</span></label>
                                <input type="url" id="href" name="href" placeholder="https://example.com"
                                    className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 transition-colors ${getFieldError("href") ? "border-red-300" : "border-gray-300"}`}
                                    onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.href} />
                                {getFieldError("href") && <p className="text-red-500 text-xs mt-1">{getFieldError("href")}</p>}
                            </div>
                        </div>
                    </div>

                    {/* Country Targeting */}
                    <div className="border-b border-gray-200 pb-6">
                        <h2 className="text-lg font-semibold text-gray-900 mb-1 flex items-center gap-2">
                            <Globe size={18} className="text-purple-600" /> Target Countries
                        </h2>
                        <p className="text-sm text-gray-500 mb-4">
                            Select which countries should see this ad. Leave as <strong>All Countries</strong> to show to everyone globally.
                        </p>
                        <CountryMultiSelect
                            value={formik.values.target_countries}
                            onChange={(codes) => formik.setFieldValue('target_countries', codes)}
                        />
                        {formik.values.target_countries.length === 0 ? (
                            <p className="text-xs text-green-600 mt-2 flex items-center gap-1">
                                <Globe size={12} /> This ad will be shown globally to all users
                            </p>
                        ) : (
                            <p className="text-xs text-purple-600 mt-2">
                                This ad will only appear to users in the {formik.values.target_countries.length} selected countr{formik.values.target_countries.length === 1 ? 'y' : 'ies'}
                            </p>
                        )}
                    </div>

                    {/* Media Files */}
                    <div className="border-b border-gray-200 pb-6">
                        <h2 className="text-lg font-semibold text-gray-900 mb-4">Media Files</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Main {formik.values.file_type === "image" ? "Image" : "Video"}</label>
                                <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-primary-500 transition-colors">
                                    <input type="file" accept={formik.values.file_type === "image" ? "image/*" : "video/*"}
                                        onChange={(e) => handleFileChange(e, "file")} className="hidden" id="file-upload" />
                                    <label htmlFor="file-upload" className="cursor-pointer">
                                        <Upload className="mx-auto h-12 w-12 text-gray-400" />
                                        <p className="mt-2 text-sm text-gray-600">Choose {formik.values.file_type === "image" ? "Image" : "Video"}</p>
                                        <p className="text-xs text-gray-500 mt-1">{formik.values.file_type === "image" ? "JPG, PNG, GIF (Max 5MB)" : "MP4, AVI, MOV (Max 50MB)"}</p>
                                    </label>
                                </div>
                                {fileList.length > 0 && (
                                    <div className="mt-2">
                                        <p className="text-sm text-green-600">✓ {fileList[0].name}</p>
                                        <Button variant="outline" size="sm" onClick={() => handleFileRemove("file")} className="text-red-600 hover:text-red-800">Remove</Button>
                                    </div>
                                )}
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Thumbnail Image</label>
                                <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-primary-500 transition-colors">
                                    <input type="file" accept="image/*" onChange={(e) => handleFileChange(e, "thumbnail_image")} className="hidden" id="thumbnail-upload" />
                                    <label htmlFor="thumbnail-upload" className="cursor-pointer">
                                        <Upload className="mx-auto h-12 w-12 text-gray-400" />
                                        <p className="mt-2 text-sm text-gray-600">Choose Thumbnail</p>
                                        <p className="text-xs text-gray-500 mt-1">Optional thumbnail for video previews</p>
                                    </label>
                                </div>
                                {thumbnailList.length > 0 && (
                                    <div className="mt-2">
                                        <p className="text-sm text-green-600">✓ {thumbnailList[0].name}</p>
                                        <Button variant="outline" size="sm" onClick={() => handleFileRemove("thumbnail_image")} className="text-red-600 hover:text-red-800">Remove</Button>
                                    </div>
                                )}
                            </div>
                        </div>
                        {(previewUrl || thumbnailPreviewUrl) && (
                            <div className="mt-6">
                                <h3 className="text-sm font-medium text-gray-700 mb-2">Preview</h3>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    {previewUrl && (
                                        <div className="border border-gray-200 rounded-lg p-4 bg-gray-50">
                                            <h4 className="text-xs font-medium text-gray-600 mb-2">Main {formik.values.file_type === "image" ? "Image" : "Video"}</h4>
                                            {formik.values.file_type === "image" ? (
                                                <img src={previewUrl} alt="preview" className="w-full h-auto max-h-48 object-contain rounded" />
                                            ) : (
                                                <video src={previewUrl} controls className="w-full h-auto max-h-48 object-contain rounded" />
                                            )}
                                        </div>
                                    )}
                                    {thumbnailPreviewUrl && (
                                        <div className="border border-gray-200 rounded-lg p-4 bg-gray-50">
                                            <h4 className="text-xs font-medium text-gray-600 mb-2">Thumbnail</h4>
                                            <img src={thumbnailPreviewUrl} alt="thumbnail preview" className="w-full h-auto max-h-48 object-contain rounded" />
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Actions */}
                    <div className="flex gap-4 pt-6">
                        <Button type="button" variant="outline" onClick={() => navigate(`${basePath}/cta-management`)}>Cancel</Button>
                        <Button type="submit" disabled={isCreating} className="flex items-center gap-2">
                            <Save size={16} /> {isCreating ? "Creating Ad..." : "Create Ad"}
                        </Button>
                    </div>
                </form>
            </Card>
        </div>
    );
};

export default CTAAdd;